import {
  WorkCommunication,
  WorkDetail,
  WorkLocation,
} from "src/domain/model/past_case_project";
import {
  Multi_SkillTag,
  Occupation_SkillTag,
  Single_SkillTag,
} from "src/domain/model/skill_tag";
import { Role as ClientRole } from "../../../../domain/model/client";
import {
  PaymentCycle as CompanyPaymentCycle,
  PaymentMethod as CompanyPaymentMethod,
  Plan as CompanyPlan,
} from "../../../../domain/model/company";
import {
  BrokerageProjectPossibility,
  Status as CustomerStatus,
  FullTimePossibility,
  Gender,
  WorkIntention,
} from "../../../../domain/model/customer";
import { EmploymentStatus } from "../../../../domain/model/job_career";
import { Occupation } from "../../../../domain/model/project";
import { OrderBy } from "../../../../domain/repository/customer_repository";

// company
namespace companyConfig {
  export const businessList = [
    "不明",
    "農業・林業・漁業",
    "鉱業",
    "建設業",
    "製造業",
    "電気・ガス業",
    "情報通信業",
    "運輸業",
    "卸売・小売業",
    "飲食業",
    "金融・保険業",
    "不動産業",
    "サービス業",
    "宿泊業",
    "教育・学習支援業",
    "医療・福祉",
    "学術・開発研究機関",
    "公務",
    "政治・経済・文化団体",
    "その他",
  ];

  export const employeeScaleList = [
    "不明",
    "10人以下",
    "10~100人規模",
    "100~1000人規模",
    "1000人以上",
  ];

  export const plan = "プラン";

  export const planList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "ショット"],
    [CompanyPlan.Plan_Light, "ライト"],
    [CompanyPlan.Plan_Standard, "スタンダード"],
    [CompanyPlan.Plan_Premium, "マスター"],
  ]);

  export const monthlyUsageFee = "月額利用料";

  export const monthlyUsageFeeList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "0円"],
    [CompanyPlan.Plan_Light, "5万円"],
    [CompanyPlan.Plan_Standard, "10万円"],
    [CompanyPlan.Plan_Premium, "25万円"],
  ]);

  export const annualUsageFee = "年額利用料";

  export const annualUsageFeeList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "0円"],
    [CompanyPlan.Plan_Light, "60万円"],
    [CompanyPlan.Plan_Standard, "120万円"],
    [CompanyPlan.Plan_Premium, "300万円"],
  ]);

  export const paymentMethod = "支払い方法";

  export const paymentMethodList: Map<CompanyPaymentMethod, string> = new Map([
    [CompanyPaymentMethod.PaymentMethod_Unknown, "不明"],
    [CompanyPaymentMethod.PaymentMethod_Bank, "振り込み"],
  ]);

  export const paymentCycle = "支払いサイクル";

  export const paymentCycleList: Map<CompanyPaymentCycle, string> = new Map([
    [CompanyPaymentCycle.PaymentCycle_Unknown, "不明"],
    [CompanyPaymentCycle.PaymentCycle_Monthly, "毎月の分割払い"],
  ]);

  export const startedPlanAt = "プラン開始日";

  export const endedPlanAt = "プラン更新日";

  export const planPeriod = "期間";

  export const billingDate = "請求日";

  export const contractFee = "成約手数料";

  export const contractFeeList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "150万円"],
    [CompanyPlan.Plan_Light, "90万円"],
    [CompanyPlan.Plan_Standard, "70万円"],
    [CompanyPlan.Plan_Premium, "30万円"],
  ]);

  export const scoutCount = "スカウト数";

  export const scoutCountList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "5件/月"],
    [CompanyPlan.Plan_Light, "20件/月"],
    [CompanyPlan.Plan_Standard, "無制限"],
    [CompanyPlan.Plan_Premium, "無制限"],
  ]);

  export const projectSupportCount = "案件作成サポート数";

  export const projectSupportCountList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "初回1回のみ"],
    [CompanyPlan.Plan_Light, "初回1回のみ"],
    [CompanyPlan.Plan_Standard, "1件/月"],
    [CompanyPlan.Plan_Premium, "1件/月"],
  ]);

  export const expartSupportCount = "人選サポート数";

  export const expartSupportCountList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "初回1案件 2件のみ"],
    [CompanyPlan.Plan_Light, "初回1案件 2件のみ"],
    [CompanyPlan.Plan_Standard, "2名/案件"],
    [CompanyPlan.Plan_Premium, "2名/案件"],
  ]);

  export const matchingSupport = "マッチングサポート";

  export const matchingSupportList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "初回1回のみ"],
    [CompanyPlan.Plan_Light, "初回1回のみ"],
    [CompanyPlan.Plan_Standard, "1件/月"],
    [CompanyPlan.Plan_Premium, "1件/月"],
  ]);

  export const interviewReport = "面談レポート";

  export const interviewReportList: Map<CompanyPlan, string> = new Map([
    [CompanyPlan.Plan_Unknown, "不明"],
    [CompanyPlan.Plan_Spot, "なし"],
    [CompanyPlan.Plan_Light, "なし"],
    [CompanyPlan.Plan_Standard, "あり"],
    [CompanyPlan.Plan_Premium, "あり"],
  ]);
}
// client
namespace clientConfig {
  export const name: string = "氏名";
  export const nameKana: string = "ふりかな";
  export const position: string = "役職";
  export const phoneNumber: string = "電話番号";

  export const roleList: Map<ClientRole, string> = new Map([
    [ClientRole.Role_Unknown, "不明"],
    [ClientRole.Role_Admin, "管理者"],
    [ClientRole.Role_Member, "メンバー"],
  ]);
}

// project
namespace projectConfig {
  export const nameLabel = "案件名";
  export const descriptionLabel = "業務内容";
  export const backgroundLabel = "募集背景";
  export const preferentialExperienceLabel = "求める経験";
  export const paymentRangeLabel = "報酬目安（円/月）";
  export const workingHourRangeLabel = "稼働時間（時/月）";
  export const placeLabel = "稼働場所";
  export const occupationsLabel = "職種区分（複数選択可能）";
  export const operatingDateLabel = "稼働希望年月";
  export const workingDurationLabel = "稼働期間";
  export const statusLabel = "公開設定";

  export const paymentRange = "報酬/月";
  export const workingHourRange = "時間/月";

  export const placeList = ["不明", "自社", "リモート", "その他"];

  export const occupation = "職種";
  export const occupationLabel = "職種";
  export const occupationList: Map<Occupation, string> = new Map([
    [Occupation.Occupation_Unknown, "不明"],
    [Occupation.Occupation_CorporateBusinessPlanning, "経営企画"],
    [Occupation.Occupation_BusinessDevelopment, "新規事業開発"],
    [Occupation.Occupation_Marketing, "マーケティング"],
    [Occupation.Occupation_PublicRelations, "広報"],
    [Occupation.Occupation_WebMarketing, "Webマーケティング"],
    [Occupation.Occupation_Sales, "営業"],
    [Occupation.Occupation_Finance, "経理/財務"],
    [Occupation.Occupation_HumanResource, "人事"],
    [Occupation.Occupation_MinistryOfJustice, "法務"],
    [Occupation.Occupation_InformationSystem, "情報システム"],
    [Occupation.Occupation_Engineer, "エンジニア"],
    [Occupation.Occupation_Designer, "デザイナー"],
    [Occupation.Occupation_IPO, "IPO関連"],
    [Occupation.Occupation_Professor, "研究者/教授"],
    [Occupation.Occupation_Other, "その他"],
  ]);

  export const operatingFrequencyList = [
    "不明",
    "週1日未満",
    "週２〜３日",
    "週４日以上",
  ];

  export const workingHourRangeList = [
    "不明",
    "20〜40時間",
    "40〜80時間",
    "80〜120時間",
    "120時間以上",
    "その他",
  ];

  export const paymentRangeList = [
    "不明",
    "10万円以下",
    "10〜30万円",
    "30〜50万円",
    "50〜100万円",
    "100万円以上",
  ];

  export const workingDurationList = [
    "不明",
    "1ヶ月以内",
    "1〜3ヶ月以内",
    "3〜6ヶ月",
    "6〜12ヶ月",
    "12ヶ月以上",
  ];

  export const statusList = [
    "不明",
    "公開",
    "下書き",
    "公開終了",
    "公開終了",
    "限定公開",
  ];
}

// customer
namespace customerConfig {
  export const name: string = "氏名";
  export const nameKana: string = "ふりかな";
  export const phoneNumber: string = "電話番号";
  export const birthDate: string = "生年月日";
  export const gender: string = "性別";
  export const pr: string = "自己PR";
  export const dutySummary: string = "職務要約";
  export const requestedCondition: string = "その他希望条件";
  export const address: string = "所在地";
  export const requirements: string = "資格";
  export const languages: string = "語学";
  export const academicBackgrounds: string = "最終学歴";
  export const workingFrequency = "希望稼働頻度";
  export const requestedFee = "月額報酬目安（週1回稼働の場合）";
  export const workIntention = "稼働スタンス";
  export const fullTimePossibility = "将来的な正社員、正規役員契約の可能性";
  export const brokerageProjectPossibility =
    "コンサルティングファーム等の仲介案件";

  // ~labelはブレがあった時の吸収用だった
  export const workingFrequencyLabel = "稼働希望時間";
  export const requestedFeeLabel = "月額報酬目安（週1回稼働の場合）";

  export const languageList = [
    "不明",
    "英語",
    "韓国語",
    "中国語",
    "スペイン語",
    "ドイツ語",
    "フランス語",
    "その他",
  ];

  export const speakingLebelList = ["不明", "", "", ""];

  export const genderList: Map<Gender, string> = new Map([
    [Gender.Gender_Unknown, "選択しない"],
    [Gender.Gender_Male, "男性"],
    [Gender.Gender_Female, "女性"],
  ]);

  export const statusList: Map<CustomerStatus, string> = new Map([
    [CustomerStatus.Status_Unknown, "不明"],
    [CustomerStatus.Status_Inspection, "審査中"],
    [CustomerStatus.Status_Denied, "拒否"],
    [CustomerStatus.Status_Active, "アクティブ"],
    [CustomerStatus.Status_BAN, "Ban"],
    [CustomerStatus.Status_Delete, "退会"],
    [CustomerStatus.Status_PassedInspection, "審査通過"],
    [CustomerStatus.Status_NonPassedInspection, "審査不通過"],
    [CustomerStatus.Status_Suspend, "休会"],
    [CustomerStatus.Status_Hidden, "非表示"],
  ]);

  export const workIntentionList: Map<WorkIntention, string> = new Map([
    [WorkIntention.WorkIntention_Unknown, ""],
    [WorkIntention.WorkIntention_OnlyAdvice, "アドバイザリーのみ"],
    [WorkIntention.WorkIntention_WithWork, "一部、手を動かすワークも可能"],
    [
      WorkIntention.WorkIntention_Consultation_Required,
      "稼働内容に関しては要相談",
    ],
  ]);

  export const fullTimePossibilityList: Map<FullTimePossibility, string> =
    new Map([
      [FullTimePossibility.FullTimePossibility_Unknown, ""],
      [
        FullTimePossibility.FullTimePossibility_Yes,
        "完全に可能性がゼロではない",
      ],
      [FullTimePossibility.FullTimePossibility_No, "完全に可能性なし"],
    ]);

  export const brokerageProjectPossibilityList: Map<
    BrokerageProjectPossibility,
    string
  > = new Map([
    [BrokerageProjectPossibility.BrokerageProjectPossibility_Unknown, ""],
    [BrokerageProjectPossibility.BrokerageProjectPossibility_Yes, "可能"],
    [BrokerageProjectPossibility.BrokerageProjectPossibility_No, "不可能"],
  ]);

  // 希望稼働頻度
  export const workingFrequencyList = [
    "不明",
    "週1日以下",
    "週1日〜2日",
    "週2日〜3日",
    "週3日以上",
    "要相談",
  ];

  // 希望報酬
  export const requestedFeeList = [
    "不明",
    "40万円以上",
    "30〜39万円程",
    "20〜29万円程",
    "19万円以下",
  ];

  // 並び替え機能
  export const orderByList: Map<OrderBy, string> = new Map([
    [OrderBy.OrderBy_CreatedAt_DESC, "新規登録順"],
    [OrderBy.OrderBy_Bookmark_DESC, "お気に入り登録順"],
  ]);
}

namespace prefectureConfig {
  export const addressList = [
    "不明",
    "東京都",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "神奈川県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
    "海外",
  ];
}

// contract
namespace contractConfig {
  export const statusList = ["不明", "承認待ち", "承認済み", "キャンセル"];
}

// jobCareer
namespace jobCareerConfig {
  // export const jobStatusNow = "在職中";
  export const employmentStatus = "契約";

  export const employmentStatusList: Map<EmploymentStatus, string> = new Map([
    [EmploymentStatus.EmploymentStatus_Unknown, ""],
    [EmploymentStatus.EmploymentStatus_FullTime, "正社員"],
    [EmploymentStatus.EmploymentStatus_Subcontracting, "業務委託"],
    [EmploymentStatus.EmploymentStatus_BoardMember, "役員以上"],
    [EmploymentStatus.EmploymentStatus_Other, "その他"],
  ]);
}

// PastCaseProject
namespace pastCaseProjectConfig {
  export const workLocation = "稼働方法";
  export const workCommunication = "コミュニケーションの方法";
  export const workDetail = "稼働の内容";

  export const workLocationList: Map<WorkLocation, string> = new Map([
    [WorkLocation.WorkLocation_UnKnown, ""],
    [WorkLocation.WorkLocation_Remote, "リモート"],
    [WorkLocation.WorkLocation_Attendance, "出勤"],
    [WorkLocation.WorkLocation_Both, "リモート&出勤"],
  ]);

  export const workCommunicationList: Map<WorkCommunication, string> = new Map([
    [WorkCommunication.WorkCommunication_Unknown, ""],
    [WorkCommunication.WorkCommunication_Chat, "ビジネスチャット"],
    [WorkCommunication.WorkCommunication_Mail, "メール"],
    [WorkCommunication.WorkCommunication_Other, "その他"],
  ]);

  export const workDetailList: Map<WorkDetail, string> = new Map([
    [WorkDetail.WorkDetail_Unknown, ""],
    [WorkDetail.WorkDetail_OnlyMtg, "ミーティングのみ"],
    [WorkDetail.WorkDetail_Mtg_ActualWorking, "ミーティング+実稼働"],
  ]);
}

// スキルタグ
namespace skillTagConfig {
  export const singleSkillTagCategoryTextList = [
    "不明",
    "得意フェーズ",
    "組織フィット",
    "得意サービス区分",
  ];

  export const multiSkillTagCategoryTextList = [
    "不明",
    "その他の経験",
    "CxOの経験",
    "導入運用経験ツール",
    "得意業界",
    "海外進出",
    "プログラミング言語",
    "開発フレームワーク",
    "AI専門領域",
    "コネクション・人脈",
  ];

  export const occupationSkillTagCategoryTextList = [
    "不明",
    "経営",
    "マーケティング",
    "営業",
    "事業開発",
    "PR",
    "広報",
    "財務",
    "グループマネジメント",
    "IR",
    "管理会計",
    "事務・アシスタント",
    "販売・サービス職",
    "人事",
    "コンサル",
    "行政担当",
    "銀行対応",
    "技術職",
    "IPO準備",
    "研究開発",
  ];

  export const singleSkillTagCategoryList: Map<
    Single_SkillTag.Category,
    string
  > = new Map([
    [Single_SkillTag.Category.Category_Unknown, "不明"],
    [Single_SkillTag.Category.Category_GoodPhase, "得意フェーズ"],
    [Single_SkillTag.Category.Category_Fit, "組織フィット"],
    [
      Single_SkillTag.Category.Category_GoodServiceClassification,
      "得意サービス区分",
    ],
  ]);

  export const multiSkillTagCategoryList: Map<Multi_SkillTag.Category, string> =
    new Map([
      [Multi_SkillTag.Category.Category_Unknown, "不明"],
      [Multi_SkillTag.Category.Category_Other, "その他の経験"],
      [Multi_SkillTag.Category.Category_CXO, "CxOの経験"],
      [
        Multi_SkillTag.Category.Category_IntroductionOperation,
        "導入運用経験ツール",
      ],
      [Multi_SkillTag.Category.Category_SpecialtyIndustry, "得意業界"],
      [Multi_SkillTag.Category.Category_OverseasExpansion, "海外進出"],
      [Multi_SkillTag.Category.Category_Programming, "プログラミング言語"],
      [Multi_SkillTag.Category.Category_DevelopFramework, "開発フレームワーク"],
      [Multi_SkillTag.Category.Category_AI, "AI専門領域"],
      [
        Multi_SkillTag.Category.Category_PersonalConnections,
        "コネクション・人脈",
      ],
    ]);

  export const occupationSkillTagCategoryList: Map<
    Occupation_SkillTag.Category,
    string
  > = new Map([
    [Occupation_SkillTag.Category.Category_Unknown, "不明"],
    [Occupation_SkillTag.Category.Category_CompanyManagement, "経営"],
    [Occupation_SkillTag.Category.Category_Marketing, "マーケティング"],
    [Occupation_SkillTag.Category.Category_Sales, "営業"],
    [Occupation_SkillTag.Category.Category_BusinessDevelopment, "事業開発"],
    [Occupation_SkillTag.Category.Category_PR, "PR"],
    [Occupation_SkillTag.Category.Category_PublicRelations, "広報"],
    [Occupation_SkillTag.Category.Category_Finance, "財務"],
    [
      Occupation_SkillTag.Category.Category_GroupManagement,
      "グループマネジメント",
    ],
    [Occupation_SkillTag.Category.Category_IR, "IR"],
    [Occupation_SkillTag.Category.Category_Accounting, "管理会計"],
    [
      Occupation_SkillTag.Category.Category_OfficeWork_Assistant,
      "事務・アシスタント",
    ],
    [Occupation_SkillTag.Category.Category_SaleService, "販売・サービス職"],
    [Occupation_SkillTag.Category.Category_HumanResource, "人事"],
    [Occupation_SkillTag.Category.Category_Consultant, "コンサル"],
    [Occupation_SkillTag.Category.Category_Administrative, "行政担当"],
    [Occupation_SkillTag.Category.Category_Bank, "銀行対応"],
    [Occupation_SkillTag.Category.Category_Technical, "技術職"],
    [Occupation_SkillTag.Category.Category_IPO, "IPO準備"],
    [Occupation_SkillTag.Category.Category_RandD, "研究開発"],
  ]);
}

export {
  clientConfig,
  companyConfig,
  contractConfig,
  customerConfig,
  jobCareerConfig,
  pastCaseProjectConfig,
  prefectureConfig,
  projectConfig,
  skillTagConfig,
};



// WEBPACK FOOTER //
// ./src/config/language/ja-JP/domain/model_text.ts